'use es6';

import { earlyMarketingDiscoveryUtilsUserAttributeRequester } from 'marketing-discovery-utils/earlyRequests/userSettingsRequester';
import { laboratoryClient } from 'FormsUI/constants/LaboratoryClient';
import { isValidDashboardUrl, isValidDashboardManageTabUrl, isEditorUrl, isInsightsValidUrl, isTemplatesUrl, getFormGUID, isCreateFormUrl, getPortalId, isEditorSettingsUrl, isAutomationUrl, isPaymentFieldUrl, isComparisonUrl, isLocalHost } from 'FormsUI/earlyRequest/urlValidator';
import { settingsFetch, editorFetch, countSubmissionsFetch, templatesFetch, flowUsagesFetch, portalScopesFetch, paymentSessionTemplatesFetch, businessUnitFetch, dataPrivacySettingsFetch, localRequestsOverrides } from 'FormsUI/earlyRequest/earlyRequestsShared';
localRequestsOverrides(isLocalHost(window.location.hostname));
earlyMarketingDiscoveryUtilsUserAttributeRequester();
if (isValidDashboardUrl(window.location.pathname)) {
  if (isValidDashboardManageTabUrl(window.location.pathname)) {
    businessUnitFetch();
  }
  laboratoryClient.resolve();
} else if (isInsightsValidUrl(window.location.pathname)) {
  const guid = getFormGUID(window.location.pathname);
  countSubmissionsFetch(guid);
} else if (isEditorUrl(window.location.pathname)) {
  if (isEditorSettingsUrl(window.location.pathname)) {
    settingsFetch();
  } else if (isAutomationUrl(window.location.pathname)) {
    const guid = getFormGUID(window.location.pathname);
    flowUsagesFetch(guid);
  } else if (isPaymentFieldUrl(window.location.pathname)) {
    paymentSessionTemplatesFetch();
  }
  const guid = getFormGUID(window.location.pathname);
  editorFetch(guid);
} else if (isCreateFormUrl(window.location.pathname)) {
  const portalId = getPortalId(window.location.pathname);
  businessUnitFetch();
  dataPrivacySettingsFetch(portalId);
  portalScopesFetch(portalId);
} else if (isTemplatesUrl(window.location.pathname)) {
  templatesFetch(getPortalId(window.location.pathname));
} else if (isComparisonUrl(window.location.pathname)) {
  businessUnitFetch();
}